import React, { Fragment, useState } from 'react'
import { formatTimeZone, priceFormat, addRankToEntries } from './../../../utils/helpers'
import PopComponent from "../Popup/PopupComponent";
import moment from 'moment-timezone'
import { TIME_ZONE, IMAGE_PREVIEW_FORMAT } from '../../constans/moment'
import AwardPreviewImage from "./AwardPreviewImage";

const ShowEntries = ({entry, index}) => {

  let icon = ''
  switch (entry.rank || index + 1) {
    case 1: {icon = "/images/icon_awards-1_b.svg"; break;}
    case 2: {icon = "/images/icon_awards-2_m.svg"; break;}
    case 3: {icon = "/images/icon_awards-3_m.svg"; break;}
    default: ''
  }
  return (
    <div className="hall-of-fame-top-third__item">
      <div className="hall-of-fame-top-third__item__info-user">
        <div className="d-flex align-items-center mr-2">
        <img
          className="hall-of-fame-top-third__item__icon-rank pr-2"
          src={icon}
        />
        <AwardPreviewImage entry={entry} className="hall-of-fame-top-third__item__info-user__avatar" />
        </div>
        <div className="d-flex justify-content-between align-items-center hall-of-fame-top-third__item__info-user__right">
          <label className="hall-of-fame-top-third__item__info-user__name text-truncate mr-2">
            {entry?.user?.nickname}
          </label>
          <label className="hall-of-fame-top-third__item__info-user__point">
            {priceFormat(entry?.total_vote || 0)}
          </label>
        </div>
      </div>
    </div>
  )
}

const HallOfFame = ({
  award = {},
}) => {

  return (
    <Fragment>
      <div className="hall-of-fame-item">
        <div className="hall-of-fame-item__title">
          <div className="hall-of-fame-item__title__time">
            <div className="time-for-seasonal">
              <label className="time-for-seasonal__year text-uppercase">
                {award.year} {award.season_label}
              </label>
            </div>
            <div className="hall-of-fame-content-intro">
              <label className="hall-of-fame-content-intro__date-time">
                {award.year} {award.season}
              </label>
              <label className="hall-of-fame-content-intro__text text-truncate w-100">
                스포키즈 {award.name} AWARDS
              </label>
            </div>
          </div>
        </div>
        <div className="hall-of-fame-top-third">
          {addRankToEntries(award.entries_trashed || []).map((entry, key) => 
            <ShowEntries entry={entry} key={key} index={key} />
          )}
        </div>
      </div>
    </Fragment>
  )
}

export default HallOfFame;
